import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Typography, Checkbox} from "@material-ui/core";
import {IConnections, IDataPartner} from "../../../types";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';


interface IProps {
    connections: IConnections
    partnerData: IDataPartner
}

interface Istate {
    modo: "diaria" | "semanal" | "mensual"
    otro: boolean
}


class UsuariosActivos extends React.Component<IProps, Istate> {

    state:Istate = {
        modo: "diaria",
        otro: false
    }


    componentDidMount() {
        if (!this.props.partnerData.hasOwnProperty("plots")) {
            setTimeout(() => this.componentDidMount(), 200)
            return
        }
        if (!this.props.partnerData.hasOwnProperty("users")) {
            setTimeout(() => this.componentDidMount(), 200)
            return
        }

        let users_basico = [] as string[]
        let users_avanzado = [] as string[]
        let users_profesional = [] as string[]
        let users_otro = [] as string[]

        for (let user of this.props.partnerData.users) {
            if (user.level === 1) {
                users_basico.push(user.nombre as string)
            } else if (user.level === 2) {
                users_avanzado.push(user.nombre as string)
            } else if (user.level === 3) {
                users_profesional.push(user.nombre as string)
            } else {
                users_otro.push(user.nombre as string)
            }
        }

        if (users_otro.length > 0) {
            this.setState({otro: true})
        }

    }


    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: "center",
                    width: '100%',
                    height: '100%',
                    backgroundColor: "white",
                    borderRadius: 20
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        height: 60,
                        width: '100%',
                        marginTop: 20
                    }}
                >
                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginLeft: 40
                        }}
                    >
                        Usuarios activos
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: 400,
                            height: "100%",
                            marginRight: 'calc(10%)'
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "black"}}
                                checked={this.state.modo === "diaria"}
                                onChange={() => this.setState({modo: "diaria"})}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14
                                }}
                            >
                                Diaria
                            </Typography>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginLeft: 10,
                                marginRight: 10
                            }}
                        >
                            <Checkbox
                                style={{color: "black"}}
                                checked={this.state.modo === "semanal"}
                                onChange={() => this.setState({modo: "semanal"})}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14
                                }}
                            >
                                Semanal
                            </Typography>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "black"}}
                                checked={this.state.modo === "mensual"}
                                onChange={() => this.setState({modo: "mensual"})}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14
                                }}
                            >
                                Mensual
                            </Typography>
                        </div>


                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 'calc(100% - 40px)',
                        height: 'calc(100% - 100px)'
                    }}
                >
                    {Object.keys(this.props.connections).length > 0 &&
                        <ResponsiveContainer
                            width="100%"
                            height="100%"
                        >

                            <BarChart
                                margin={{
                                    top: 0,
                                    right: 0,
                                    left: 30,
                                    bottom: 30,
                                }}
                                data={this.props.connections[this.state.modo]}
                                barCategoryGap={5}
                                barGap={0}
                            >

                                <Tooltip wrapperStyle={{fontSize: 14, fontFamily: "Poppins"}}/>
                                <XAxis dataKey="name" type="category" style={{fontSize: 14, fontFamily: "Poppins"}}/>
                                <YAxis type="number"/>
                                <CartesianGrid strokeDasharray={"3 3"} horizontal={true} vertical={true}/>
                                <Bar dataKey="basico" fill="#FF7777" stackId="a"/>
                                <Bar dataKey="avanzado" fill="#694BDB" stackId="a"/>
                                <Bar dataKey="profesional" fill="#2BEBC8" stackId="a"/>
                                {this.state.otro &&
                                    <Bar dataKey="otro" fill="#f6d947" stackId="a"/>
                                }
                                {this.props.connections[this.state.modo].length > 7 &&
                                    <Brush
                                        height={20}
                                        stroke="#4C494B"
                                        startIndex={this.props.connections[this.state.modo].length - 7}
                                        endIndex={this.props.connections[this.state.modo].length - 1}
                                        dataKey="name"
                                    />
                                }

                            </BarChart>

                        </ResponsiveContainer>
                    }

                </div>


            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    connections: state.partner.connections,
    partnerData: state.partner.dataPartner
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(UsuariosActivos);
